








import { Vue, Component } from "vue-property-decorator"
// @ts-ignore
import zhCN from "ant-design-vue/lib/locale-provider/zh_CN"
import moment from "moment"
import "moment/locale/zh-cn"

moment.locale('zh-cn');

@Component
export default class extends Vue {
  locale: any = zhCN;

  year: string = moment().format('YYYY');
}
